import {createSlice, Draft, PayloadAction} from "@reduxjs/toolkit";
import { createMultiOptions } from "../../../../utils/createOptions";

const initialState: any = {
  integrationErrors: null,
  integrationErrorsCount: null,
  limit: JSON.parse(localStorage.getItem("pageLimit") as string) || 10,
  offset: 0,
  filters: [],
  integrationErrorsInputValues: {
    date: "",
    types: null,
    description: "",
    visitNo: "",
    address: "",
    contracts: [],
    projects: [],
    merchs: [],
    sv: [],
    vsv: [],
    personId: "",
    userId: "",
  },
};

export const integrationErrorsSlice = createSlice({
  name: "integrationErrors",
  initialState,
  reducers: {
    reducerGetIntegrationErrors: (
      state: Draft<any>,
      action: PayloadAction<any>
    ) => {
      state.integrationErrors = action?.payload?.data?.incidents?.data || [];
      state.integrationErrors.forEach((error: any, index: number) => {
        if (error.visitDate ) {
          state.integrationErrors.sort((a: any, b: any) => new Date(b.visitDate).getTime() - new Date(a.visitDate).getTime());
        }
    });
      state.integrationErrorsCount = action?.payload?.data?.incidents?.count;
      state.integrationErrorsFilter = action?.payload?.data?.incidentFilter;
      state.limit = action.payload.limit;
      state.offset = action.payload.offset;
      state.lastUpdate = action?.payload?.data?.lastUpdate;
      state.contractOptions = createMultiOptions(action?.payload?.data?.incidentFilter?.contracts);
      state.projectOptions = createMultiOptions(action?.payload?.data?.incidentFilter?.projects);
      state.merchsOptions = createMultiOptions(action?.payload?.data?.incidentFilter?.merchs);
      state.svOptions = createMultiOptions(action?.payload?.data?.incidentFilter?.sv);
      state.vsvOptions = createMultiOptions(action?.payload?.data?.incidentFilter?.vsv);
    },
    reducerIntegrationErrorsInputValues: (
      state: Draft<any>,
      action: PayloadAction<any>
    ) => {
      state.integrationErrorsInputValues = {...state.integrationErrorsInputValues,...action.payload};
    },
    reducerIntegrationErrorsStatus: (
      state: Draft<any>,
      action: PayloadAction<any>
    ) => {
      state.status = action.payload;
    },
    reducerIntegrationErrorsClearInputValues: () => {
      return initialState;
    }
  },
});

export const {
  reducerIntegrationErrorsInputValues,
  reducerIntegrationErrorsStatus,
  reducerGetIntegrationErrors,
  reducerIntegrationErrorsClearInputValues
} = integrationErrorsSlice.actions;

export default integrationErrorsSlice.reducer;
